import { useState } from "react";
import { Form } from "react-bootstrap";

import CircularProgress from "@mui/material/CircularProgress";

import { rootURL } from "../utilities/axios-config";
import { Button, IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { failedMessage, successMessage } from "../utilities/alert-config";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import dayjs from "dayjs";
import { useS3UploadMultipleFiles } from "../../hooks/useS3";
import { deleteFile } from "../../utilities/s3Bucket";
import { GrAttachment } from "react-icons/gr";
import { v4 as uuidv4 } from "uuid";

function CommentComponent({
  comment,
  setShowImageModal,
  setSelectedImage,
  setNewComment,
  setShowAddComment,
  style,
}) {
  const userId = localStorage.getItem("id");
  const userRole = localStorage.getItem("role");
  const showEditIcon = (user_id) => user_id === Number(userId);
  const showDeleteIcon = (user_id) =>
    user_id === Number(userId) || user_id === "" || Number(userRole) === 3;
  const { uploadFiles } = useS3UploadMultipleFiles();

  //   const [newComment, setNewComment] = useState("");
  const [replyComment, setReplyComment] = useState("");
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [editingComment, setEditingComment] = useState(null);
  const [replingComment, setReplingComment] = useState(null);
  const [editCommentFiles, setEditCommentFiles] = useState([]);
  //   const [loading2, setloading2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addNewCommentStatus, setAddNewCommentStatus] = useState(null);
  //   const [showAddComment, setShowAddComment] = useState(false);

  const [showRepliesCommentId, setShowRepliesCommentId] = useState(null);
  const [replies, setReplies] = useState([]);
  const [repliesLoading, setRepliesLoading] = useState(false);

  const handleCommentFileChange = async (event) => {
    setAttachedFiles((prev) => [...prev, ...Array.from(event.target.files)]);
  };

  const handleDeleteOldCommentImage = async (comment, imageUrl) => {
    try {
      if (window.confirm("Are you sure you want to delete this image?")) {
        await deleteFile(imageUrl);
        // console.log("deleteFile results", results);
        const currentImageUrls = comment.images_urls.filter(
          (url) => url !== imageUrl
        );
        const commentData = {
          content: comment.content,
          images_urls: currentImageUrls,
        };
        const userToken = localStorage.getItem("userToken");
        const config = {
          headers: {
            Authorization: `Bearer ${userToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        let url = `${rootURL}/kanban/comments/${comment.id}`;
        fetch(url, {
          method: "PUT",
          headers: config.headers,
          body: JSON.stringify(commentData),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("data", data);
            if (data.success === true) {
              successMessage("Success");
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            } else if (data.success === false) {
              failedMessage("Failed");
            }
          })
          .catch((error) => {
            console.error("Error updating comment:", error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickEditComment = (comment) => {
    setShowAddComment(false);
    setEditingComment(comment);
    setReplingComment(null);
  };

  const handleClickReplingComment = (comment) => {
    setShowAddComment(false);
    setEditingComment(null);
    setNewComment("");
    setEditCommentFiles([]);
    setReplingComment(comment);
  };

  const handleUpdateComment = async () => {
    if (editingComment.content.trim() === "") return;

    setLoading(true);
    let imageUrls = [];
    if (editCommentFiles.length > 0) {
      setAddNewCommentStatus("Uploading...");
      const uploadFilesUrls = await uploadFiles(editCommentFiles);
      if (uploadFilesUrls) {
        imageUrls = uploadFilesUrls;
      }
    }

    const updatedComment = {
      content: editingComment.content.trim(),
      images_urls:
        editingComment?.images_urls?.length > 0 && imageUrls?.length > 0
          ? [...editingComment?.images_urls, ...imageUrls]
          : editingComment?.images_urls?.length > 0
          ? editingComment?.images_urls
          : imageUrls?.length > 0
          ? imageUrls
          : [],
    };

    const userToken = localStorage.getItem("userToken");
    setAddNewCommentStatus("Updating...");
    try {
      const response = await axios.put(
        `${rootURL}/kanban/comments/${editingComment.id}`,
        updatedComment,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const result = response.data;
      // console.log("result>>>>>", result);
      if (result.success === true) {
        successMessage("Success");
        // Reset edit mode
        setEditingComment(null);
        setNewComment("");
        setEditCommentFiles([]);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (result.success === false) {
        failedMessage(result.message);
      }
    } catch (error) {
      failedMessage(error.message || "An error occurred");
    } finally {
      setLoading(false);
      setAddNewCommentStatus(null);
    }
  };
  const handleGetCommentReplies = async (commentId) => {
    if (!commentId) return;

    setRepliesLoading(true);

    const userToken = localStorage.getItem("userToken");
    setAddNewCommentStatus("Updating...");
    try {
      const response = await axios.get(
        `${rootURL}/kanban/comments/${commentId}`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const result = response.data;
      console.log("handleGetCommentRepliesresult>>>>>", result);
      if (result.success === true) {
        // successMessage("Success");
        setShowRepliesCommentId(commentId);
        setReplies(result.data);
        // Reset edit mode
        // setEditingComment(null);
        // setNewComment("");
        // setEditCommentFiles([]);
      } else if (result.success === false) {
        // failedMessage(result.message);
      }
    } catch (error) {
      failedMessage(error.message || "An error occurred");
    } finally {
      setRepliesLoading(false);
      setAddNewCommentStatus(null);
    }
  };

  const handleDeleteComment = async (comment) => {
    if (window.confirm("Are you sure you want to delete this comment?")) {
      const userToken = localStorage.getItem("userToken");
      try {
        const response = await axios.delete(
          `${rootURL}/kanban/comments/${comment.id}`,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        const result = response.data;
        if (result.success === true) {
          successMessage("Success");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else if (result.success === false) {
          failedMessage(result.message);
        }
      } catch (error) {
        // console.log("Error>>>>", error);
        failedMessage(
          error.response.data.message || error.message || "An error occurred"
        );
      } finally {
        // setloading2(false);
      }
    }
  };

  const handleCommentReplySubmit = async () => {
    if (!replingComment?.id) return;
    if (replyComment.trim() === "") return;
    setLoading(true);

    let imageUrls = [];
    if (attachedFiles.length > 0) {
      setAddNewCommentStatus("Uploading...");
      const uploadFilesUrls = await uploadFiles(attachedFiles);
      if (uploadFilesUrls) {
        imageUrls = uploadFilesUrls;
      }
    }

    const newCommentData = {
      user_id: userId,
      // kanbanbord_details_id: idd,
      parent_id: replingComment.id,
      content: replyComment?.trim(),
      images_urls: imageUrls,
    };

    const userToken = localStorage.getItem("userToken");
    setAddNewCommentStatus("Saving...");
    try {
      const response = await axios.post(
        `${rootURL}/kanban/comments`,
        newCommentData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const result = response.data;
      if (result.success === true) {
        successMessage("Success");
        setNewComment("");
        setAttachedFiles([]);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (result.success === false) {
        failedMessage(result.message);
      }
    } catch (error) {
      console.log("Error>>>>", error);

      // failedMessage("Internal Server Error");
      failedMessage(error.message || "An error occurred");
    } finally {
      setLoading(false);
      setAddNewCommentStatus(null);
      setReplingComment(null);
    }
  };

  return (
    <>
      <div
        style={{
          borderBottom: "1px solid #000",
          marginBottom: "1rem",
          ...style,
        }}
      >
        {editingComment?.id === comment.id ? (
          <div>
            <Form.Control
              as="textarea"
              rows="3"
              value={editingComment?.content}
              onChange={(e) =>
                setEditingComment((prev) => ({
                  ...prev,
                  content: e.target.value,
                }))
              }
              className="mb-2"
            />

            {/* Display existing images with remove option */}
            {editCommentFiles.length > 0 && (
              <div className="mb-2">
                <p>Attached files:</p>
                {editCommentFiles.map((file, index) => (
                  <div key={index} className="d-flex align-items-center">
                    <span>{file?.name}</span>
                    <Button
                      size="small"
                      variant="text"
                      color="error"
                      onClick={() =>
                        setEditCommentFiles((prev) =>
                          prev.filter((f) => f.name !== file.name)
                        )
                      }
                    >
                      X
                    </Button>
                  </div>
                ))}
              </div>
            )}

            {/* File input for adding new files */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <Button
                variant="text"
                component="label"
                size="small"
                style={{
                  marginRight: "10px",
                  textTransform: "none",
                }}
              >
                Attach files
                <input
                  type="file"
                  hidden
                  multiple
                  onChange={(e) => {
                    const newFiles = Array.from(e.target.files);
                    setEditCommentFiles((prev) => [...prev, ...newFiles]);
                  }}
                />
              </Button>
              <div>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    setEditingComment(null);
                    setNewComment("");
                    setEditCommentFiles([]);
                  }}
                  className="me-2"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleUpdateComment}
                  disabled={!editingComment?.content?.trim() || loading}
                >
                  {loading && addNewCommentStatus
                    ? addNewCommentStatus
                    : "Update"}
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <strong>
                  {comment?.user?.first_name || "User"}
                  {comment?.user?.last_name ? ` ${comment.user.last_name}` : ""}
                </strong>
                <small className="text-muted text-xs">
                  {dayjs(comment?.created_at).format("DD/MM/YYYY HH:mm A")}
                  {comment.is_editted && " (edited)"}
                </small>
              </div>
              <div className="d-flex align-items-center gap-2">
                {showEditIcon(comment.user_id) && (
                  <Tooltip title="Edit" placement="top">
                    <IconButton
                      size="small"
                      onClick={() => handleClickEditComment(comment)}
                    >
                      <EditIcon
                        style={{
                          fontSize: 16,
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                )}
                {showDeleteIcon(comment.user_id) && (
                  <Tooltip title="Delete" placement="top">
                    <IconButton
                      size="small"
                      onClick={() => handleDeleteComment(comment)}
                    >
                      <DeleteIcon
                        style={{
                          fontSize: 16,
                          color: "#f44336",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            </div>
            <div className="mb-3">
              <p
                style={{
                  whiteSpace: "pre-line",
                }}
              >
                {comment.content}
              </p>
              {comment?.images_urls?.length > 0 && (
                <div className="mt-2 d-flex flex-wrap gap-2">
                  {comment.images_urls.map((url, i) => (
                    <div key={url} className="d-flex align-items-center">
                      <GrAttachment
                        style={{
                          fontSize: 16,
                        }}
                      />
                      <p
                        onClick={() => {
                          console.log("url", url);
                          setSelectedImage(url);
                          setShowImageModal(true);
                        }}
                        className="d-block mb-1 text-decoration-underline"
                        style={{
                          color: "#007bff",
                          cursor: "pointer",
                        }}
                      >
                        {url?.split("/").pop()?.split("_").pop()}
                      </p>
                      {showEditIcon(comment.user_id) && (
                        <Tooltip title="Delete" placement="top">
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleDeleteOldCommentImage(comment, url)
                            }
                          >
                            <CloseIcon
                              style={{
                                fontSize: 16,
                                color: "#f44336",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  ))}
                </div>
              )}

              <div>
                {replingComment?.id !== comment.id && (
                  <Button
                    variant="text"
                    color="primary"
                    size="small"
                    onClick={() => handleClickReplingComment(comment)}
                  >
                    reply
                  </Button>
                )}
                {comment?.replies_count > 0 &&
                  comment?.id !== showRepliesCommentId && (
                    <Button
                      variant="text"
                      color="primary"
                      size="small"
                      disabled={repliesLoading}
                      onClick={() => handleGetCommentReplies(comment.id)}
                    >
                      {repliesLoading ? (
                        <CircularProgress size={12} thickness={4} />
                      ) : (
                        "view replies"
                      )}
                    </Button>
                  )}
                {comment?.replies_count > 0 &&
                  comment?.id === showRepliesCommentId && (
                    <Button
                      variant="text"
                      color="primary"
                      size="small"
                      disabled={repliesLoading}
                      onClick={() => {
                        setReplies([]);
                        setShowRepliesCommentId(null);
                      }}
                    >
                      hide replies
                    </Button>
                  )}
              </div>

              {replingComment?.id === comment.id && (
                <div>
                  <Form.Group className="form-group mb-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <Form.Label>Add reply</Form.Label>
                      <Tooltip title="Cancel">
                        <IconButton
                          onClick={() => {
                            setNewComment("");
                            setReplingComment(null);
                            setReplyComment("");
                            setAttachedFiles([]);
                            // setShowAddComment(false);
                          }}
                        >
                          <CloseIcon size="small" />
                        </IconButton>
                      </Tooltip>
                    </div>
                    <div className="form-control-wrap">
                      <Form.Control
                        as="textarea"
                        rows="2"
                        placeholder="Add comment"
                        value={replyComment}
                        required
                        onChange={(e) => setReplyComment(e.target.value)}
                      ></Form.Control>
                    </div>
                  </Form.Group>

                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <Button
                        variant="contained"
                        color="warning"
                        onClick={handleCommentReplySubmit}
                        style={{
                          marginRight: "10px",
                          textTransform: "none",
                        }}
                        disabled={replyComment.trim() === "" || loading}
                      >
                        {loading && addNewCommentStatus
                          ? addNewCommentStatus
                          : "Send"}
                      </Button>
                      <Button
                        variant="text"
                        component="label"
                        style={{
                          textTransform: "none",
                          textDecoration: "underline",
                        }}
                      >
                        Attach file
                        <input
                          type="file"
                          hidden
                          multiple
                          onChange={handleCommentFileChange}
                          style={{ marginRight: "10px" }}
                        />
                      </Button>
                    </div>
                  </div>

                  {/* Display attached files */}
                  <div className="mt-2">
                    {attachedFiles.length > 0 &&
                      attachedFiles.map((file) => (
                        <div
                          key={uuidv4()}
                          className="d-flex align-items-center"
                        >
                          <span>{file?.name}</span>
                          <Button
                            size="small"
                            variant="text"
                            color="error"
                            onClick={() =>
                              setAttachedFiles((prev) =>
                                prev.filter((f) => f.name !== file.name)
                              )
                            }
                          >
                            X
                          </Button>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        {/* <hr /> */}
        {showRepliesCommentId === comment.id &&
          replies?.map((reply) => (
            <div key={uuidv4()}>
              <CommentComponent
                comment={reply}
                setShowImageModal={setShowImageModal}
                setSelectedImage={setSelectedImage}
                setNewComment={setNewComment}
                setShowAddComment={setShowAddComment}
                style={{
                  marginLeft: "40px",
                  marginRight: "8px",
                  borderBottom: "none",
                }}
              />
            </div>
          ))}
      </div>
    </>
  );
}

export default CommentComponent;
